import { CommonClientError } from "../../error";
import { DateUtils } from "../../primitive-utils";
import { REGEX_MONTH } from "../../primitive/time/base/time-regex";
import { isNullable } from "../../type-guards";
import { LocalDateFunc } from "../date";
import { MONTH_FORMAT } from "../time-format";
export class MonthFunc {
    v;
    constructor(v) {
        this.v = v;
    }
    static DUMMY_YEAR = 2020;
    static of({ month }) {
        const year = MonthFunc.DUMMY_YEAR;
        const date = new Date(year, month - 1);
        date.setFullYear(year); // new Dateに直接渡すと、yearに2桁以下が指定された際に1900年代として自動補完されてしまうのでsetFullYearで別途渡す。
        if (date.getFullYear() !== year || date.getMonth() + 1 !== month) {
            const formattedMonth = `${year}-${month}`;
            throw new CommonClientError.InvalidInput(`不正な年月です。input: ${formattedMonth}`);
        }
        return new MonthFunc({ month });
    }
    static parse(text, format = MONTH_FORMAT) {
        const d = DateUtils.fromFormat(text, format);
        if (!DateUtils.isValidDate(d)) {
            throw new CommonClientError.InvalidInput(`parse error. required: ${format}}, but actual:${text}`);
        }
        return MonthFunc.of({
            month: d.getMonth() + 1,
        });
    }
    // 正規表現からParseする。
    // ただし、数字部分が MM であることを前提とする。
    static parseFromRegex(text, regex = REGEX_MONTH) {
        if (!regex.test(text)) {
            throw new CommonClientError.InvalidInput(`Month regex match error. regex[${regex.source}], input[${text}]`, "月の形式が不正です。");
        }
        const extractRegex = /\d+/g; // 数字を抽出
        const [month] = text.match(extractRegex)?.map(Number) ?? [];
        return MonthFunc.of({
            month,
        });
    }
    // USAGE: MonthArray.sort(MonthFunc.compere);
    static compare(a, b) {
        return a.toDate().getTime() - b.toDate().getTime();
    }
    static compareDesc(a, b) {
        return b.toDate().getTime() - a.toDate().getTime();
    }
    static equals(a, b) {
        return a.toDate().getTime() === b.toDate().getTime();
    }
    /** DateをJST解釈のMonthに変換して返す */
    static fromDateJST(v) {
        const jstDate = DateUtils.utcToJSTTime(v);
        return this.fromDate(jstDate);
    }
    equals(other) {
        if (isNullable(this) && isNullable(other)) {
            return true;
        }
        if (isNullable(this) || isNullable(other)) {
            return false;
        }
        return MonthFunc.equals(this, other);
    }
    isAfter(other) {
        return this.toDate().getTime() > other.toDate().getTime();
    }
    isEqualOrAfter(other) {
        return this.equals(other) || this.isAfter(other);
    }
    isBefore(other) {
        return this.toDate().getTime() < other.toDate().getTime();
    }
    isEqualOrBefore(other) {
        return this.equals(other) || this.isBefore(other);
    }
    atDate(day) {
        return LocalDateFunc.of({
            year: MonthFunc.DUMMY_YEAR,
            month: this.v.month,
            day,
        });
    }
    atStartOfMonthDate() {
        return this.atDate(1).startOfMonth();
    }
    atEndOfMonthDate() {
        return this.atDate(1).endOfMonth();
    }
    addMonths(months) {
        return this.callAsDate((d) => DateUtils.addMonths(d, months));
    }
    subMonths(months) {
        return this.callAsDate((d) => DateUtils.subMonths(d, months));
    }
    toString() {
        const d = this.toDate();
        return DateUtils.format(d, MONTH_FORMAT);
    }
    toValues() {
        return this.v;
    }
    format(format = MONTH_FORMAT) {
        return DateUtils.format(this.toDate(), format, true);
    }
    // Dateで受け付ける関数を呼びたいときのアダプタ
    callAsDate(func) {
        const d = this.toDate();
        const result = func(d);
        return MonthFunc.fromDate(result);
    }
    toDate() {
        const year = MonthFunc.DUMMY_YEAR;
        const date = new Date(year, this.v.month - 1);
        date.setFullYear(year); // new Dateに直接渡すと、yearに2桁以下が指定された際に1900年代として自動補完されてしまうのでsetFullYearで別途渡す。
        return date;
    }
    static fromDate(d) {
        return MonthFunc.of({
            month: d.getMonth() + 1,
        });
    }
}
//# sourceMappingURL=month.js.map